import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { KudoContentObjectDetailDataObject } from 'models/service';

type CreateKudoRequest = { kudo: Kudo };

type Kudo = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  attachments?: Array<{ id: string }>;
  community_id?: string;
  html_content: string;
  pinned?: boolean;
  publish_at?: string;
  text_content: string;
  user_id: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const createKudo = async ({ body }: BodyRequest<CreateKudoRequest>) =>
  apiClient.post<KudoContentObjectDetailDataObject, ApiClientResponse<KudoContentObjectDetailDataObject>>(
    routes.kudos.create,
    body,
  );
